export const actionType: Readonly<any> = {
    ByPackage: 'By Package',
    ByLabel: 'By Label'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/actionType.ts